export default "__VITE_ASSET__CPmbD_DH__"